import { $authHost } from 'app/configs/axiosConfig';
import { ISetLoginUser, IUser } from '../types';

export const updateUserEmail = (email: string) => {
  return $authHost.patch<IUser>('/users/self', { email });
};

export const userSignOut = () => {
  return $authHost.patch('/admin/reset-login-user');
};

export const setLoginUser = (data: ISetLoginUser) => {
  return $authHost.patch('/admin/set-login-user', data);
};
